import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { KitDesc } from '../../../../shared/model';
import { KitServiceDescription, ToolTypeService } from '../../camtl.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';

@Component({
  selector: 'app-kit',
  templateUrl: './kit.component.html',
  // styleUrls: ['./kit.component.scss']
})
export class KitComponent implements OnInit {

  constructor(

    private KitServiceDescription: KitServiceDescription,
    private ToolTypeService: ToolTypeService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
  ) { }

  isNew: boolean = false;
  editDataItem: KitDesc;
  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
  editForm = new FormGroup({

    Name: new FormControl("", Validators.required),
    Status: new FormControl(false, Validators.required),
    AdditionalInfo: new FormControl(),
    Id: new FormControl(),
    CreatedDate: new FormControl(),
    CreatedBy: new FormControl(),
    ModifiedDate: new FormControl(),
    ModifiedBy: new FormControl(),

  });



  columns: any[] = [
    {
      field: "Name",
      title: "Name",
    },

    {
      field: "Status",
      title: "Status",
      width: "125",
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    },
    {
      field: "AdditionalInfo",
      title: "Additional Info",

    }
  ]

  onSave = (dataItem, isNew) => {
    var self = this;
    self.KitServiceDescription.save(dataItem, isNew, "", true, false)
      .then(function () {
        self.KitServiceDescription.loading.next(false);
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });
      }).catch(function (response) {
        self.KitServiceDescription.loading.next(false);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
  }

  template = {

    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: true,
      width: 65
    },
    columns: this.columns,
    service: this.KitServiceDescription,
    save: this.onSave,
    fileName: 'CAMTL_kit_descriptions.xlsx'
  }

  formDialog = {
    title: "Kit",
    formControls: [
      {
        type: "text",
        name: "Name",
        title: "Name",
        readonly: "never",
      },


      {
        type: "boolean",
        name: "Status",
        title: "Active",
        readonly: "never",

      },
      {
        type: "text",
        name: "AdditionalInfo",
        title: "Additional Info",

      }
    ],
  }


  public ngOnInit(): void {
    this.KitServiceDescription.query();
  }

  setModelHandler() {
    this.editDataItem = new KitDesc();
    this.editDataItem.Status = false;
    // console.log(this.formDialog)
  }

}